<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/magazine_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>雜誌專區</h1>
          <div class="banner-text-line"></div>
          <span>Magazine Area</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <div class="d-flex justify-content-center">
          <div
            class="list-group list-group-horizontal list-bg list-area rounded-pill"
            id="list-tab"
            role="tablist"
          >
            <a
              class="list-group-item active text-center rounded-pill"
              id="list-magazine-list"
              data-toggle="list"
              href="#list-magazine"
              role="tab"
              aria-controls="magazine"
              @click="setPage(true)"
              >電子會刊</a
            >
            <a
              class="list-group-item text-center rounded-pill"
              id="list-submit-list"
              data-toggle="list"
              href="#list-submit"
              role="tab"
              aria-controls="submit"
              @click="setPage(false)"
              >線上投稿</a
            >
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-magazine"
            role="tabpanel"
            aria-labelledby="list-magazine-list"
          >
            <div class="content-title">
              <h2>電子會刊</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                雜誌專區
              </div>
            </div>
            <div class="content-textBox" v-if="infiniteData.length > 0">
              <div
                class="magazine-wrap"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="10"
              >
                <template v-for="(item, index) in infiniteData">
                  <MagazineCard
                    :data="item"
                    :key="index"
                    :from="'magazine'"
                  ></MagazineCard>
                </template>
              </div>
            </div>
            <div class="content-contact" v-else>
              <div class="content-contact-border">
                <div class="member-box">
                  <h3>目前沒有內容</h3>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="list-submit"
            role="tabpanel"
            aria-labelledby="list-submit-list"
          >
            <div class="content-title">
              <h2>投稿專區</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                投稿專區
              </div>
            </div>
            <div class="content-textBox" v-if="Detail && Detail.length > 0">
              <div class="text">
                <h3>投稿辦法：</h3>
                <section v-if="Detail[0].Id">
                  <div class="box">
                    <h3 class="title">{{ Detail[0].Title }}</h3>
                    <!-- <div class="img">
                      <img :src="Detail.Image" :alt="Detail.Title" />
                    </div> -->
                    <!-- <div class="border"></div> -->
                    <div class="tr">
                      <div>投稿日期</div>
                      <div>
                        {{
                          Detail[0].StartOn.split("T")[0] +
                          " ~ " +
                          Detail[0].EndOn.split("T")[0]
                        }}
                      </div>
                    </div>
                    <div class="tr" v-if="Detail[0].DocumentFile">
                      <div>檔案下載</div>
                      <a
                        href="javascript:;"
                        @click="download(Detail[0].DocumentFile)"
                        >檔案下載</a
                      >
                    </div>
                    <div class="" v-html="Detail[0].Content"></div>
                  </div>
                  <!-- <graybtn name="回列表頁" url="back" /> -->
                </section>
              </div>
            </div>
            <div class="content-title" v-if="Detail && Detail.length > 0">
              <h2>填寫投稿人資訊</h2>
            </div>
            <div class="content-contact" v-if="Detail && Detail.length > 0">
              <div class="content-contact-border">
                <form
                  class="submission_box"
                  :class="{ active: Submission }"
                  ref="form"
                >
                  <input type="hidden" name="Id" :value="guid" />
                  <div class="input_span">
                    <span>姓名</span>
                    <input
                      type="text"
                      name="Name"
                      v-model="formData.Name"
                      placeholder="請填寫姓名"
                    />
                  </div>
                  <div class="input_span">
                    <span>聯絡電話</span>
                    <input
                      type="text"
                      name="Mobile"
                      v-model="formData.Mobile"
                      placeholder="請填寫連絡電話"
                    />
                  </div>
                  <div class="input_span">
                    <span>E-mail</span>
                    <input
                      type="text"
                      name="Email"
                      v-model="formData.Email"
                      placeholder="請填寫您的E-mail"
                    />
                  </div>
                  <!-- <div class="input_span">
                    <span>服務單位</span>
                    <input
                      type="text"
                      name="Affiliation"
                      v-model="formData.Affiliation"
                      placeholder="請填寫您目前的服務單位"
                    />
                  </div>
                  <div class="input_span">
                    <span>職稱</span>
                    <input
                      type="text"
                      name="Position"
                      v-model="formData.Position"
                      placeholder="請填寫您目前的職稱"
                    />
                  </div>
                  <div class="input_span">
                    <span>投稿標題</span>
                    <input
                      type="text"
                      name="submitTitle"
                      v-model="formData.submitTitle"
                      placeholder="請填寫您的投稿標題"
                    />
                  </div> -->
                  <div class="input_span">
                    <span>上傳檔案</span>
                    <div class="fileArea">
                      <label for="file" v-show="!fileName">上傳檔案</label>
                      <input
                        id="file"
                        ref="file"
                        type="file"
                        name="File"
                        @change="toInputValue($event)"
                      />
                      <div v-show="!fileName">※檔案請小於2.0MB</div>
                      <div class="file_name" v-show="fileName">
                        <input type="text" id="forFile" v-model="fileName" />
                        <div class="delete" @click="deleteFile">
                          <span>✖</span>
                          <span>刪除</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="btn_box">
                    <div class="item">
                      <div class="White_btn islogin" @click="reset">
                        <a href="javascript:;">重新填寫</a>
                      </div>
                    </div>
                    <div class="item">
                      <div class="Orange_btn islogin" @click="submit">
                        <a href="javascript:;">確定送出</a>
                      </div>
                    </div>
                  </div>-->
                  <div class="contact-btnBlock">
                    <div class="item">
                      <div class="btn blue-btn islogin" @click="submit">
                        <a href="javascript:;">完成送出</a>
                      </div>
                    </div>
                    <div class="item">
                      <div class="btn white-btn islogin" @click="reset">
                        <a href="javascript:;">重新填寫</a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="contact-back" v-if="Detail && Detail.length > 0">
              <router-link to="/">
                回首頁
                <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
              </router-link>
            </div>
            <div class="content-contact" v-else>
                  <div class="content-contact-border">
                    <div class="member-box">
                      <h3>目前沒有內容</h3>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import MagazineCard from '@/components/MagazineCard.vue';
import Common from '@/common';
import MagazineApi from '@/assets/api/magazine';
import SubmissionApi from '@/assets/api/submission';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Magazine',
  components: {
    MagazineCard,
  },
  data() {
    return {
      BG,
      title: '學會歷史',
      isMagazine: true,
      Detail: [],
      myFile: [],
      Submission: false,
      fileName: '',
      fullFileName: '',
      formData: {
        Name: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
        submitTitle: '',
      },
      count: 0, // 要推入的資料位置初始值
      infiniteData: [], // inifinite scroll渲染的部分
      nowPage: 1,
      busy: false, // true觸發載入，false停止載入
      totalPage: 1,
    };
  },
  methods: {
    setTitle(text) {
      const vm = this;
      vm.title = text;
      $('#collapseOne').collapse('hide');
    },
    getMagazineList(page) {
      const vm = this;
      MagazineApi.getMagazines(page).then((res) => {
        if (res.status === 200) {
          if (vm.infiniteData.length === 0) {
            vm.infiniteData = res.data.Data.Journals;
            vm.totalPage = Math.ceil(parseInt(res.data.Data.Total, 10) / 10);
          } else {
            vm.busy = false;
            vm.$store.dispatch('updateLoading', false);
            vm.infiniteData = vm.infiniteData.concat(res.data.Data.Journals);
          }
        }
      });
    },
    getSubmissionList() {
      const vm = this;
      SubmissionApi.getAllSubmission(1, 3).then((res) => {
        if (res.status === 200) {
          if (!vm.Detail.Id) {
            // 過濾還沒公布結果的投稿
            vm.Detail = res.data.Data.Submissions;
          }
        }
      });
    },
    // 無限滾動用
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (vm.totalPage === 1 || vm.totalPage === vm.nowPage) {
        vm.busy = false;
      } else {
        vm.$store.dispatch('updateLoading', true);
        vm.nowPage += 1;
        vm.getMagazineList(vm.nowPage);
      }
    },
    setPage(data) {
      const vm = this;
      vm.isMagazine = data;
    },
    // eslint-disable-next-line consistent-return
    toInputValue(e) {
      const vm = this;
      const File = e.target.files || e.dataTransfer.files;
      if (File[0].size > 6000000) {
        vm.$swal({
          type: 'warning',
          text: '檔案大小超過 6MB，請重新選擇檔案',
          confirmButtonText: '確定',
        });
        return false;
      }
      // eslint-disable-next-line prefer-destructuring
      vm.myFile = File[0];
      const tmpFileName = File[0].name.split('.');
      if (tmpFileName.length >= 2) {
        // eslint-disable-next-line prefer-destructuring
        vm.fileName = tmpFileName[0];
      } else {
        vm.fileName = File[0].name;
      }
      vm.fullFileName = File[0].name;
      if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(vm.fileName)) {
        vm.$swal({
          type: 'warning',
          text: '檔名請勿使用特殊符號或空格',
          confirmButtonText: '確定',
        }).then((data) => {
          if (data.value) {
            vm.deleteFile();
          }
        });
      }
    },
    deleteFile() {
      const vm = this;
      vm.myFile = [];
      vm.fileName = '';
      vm.fullFileName = '';
      vm.$refs.file.value = '';
    },
    // eslint-disable-next-line consistent-return
    submit() {
      const vm = this;
      if (
        !vm.formData.Name
        || !vm.formData.Mobile
        || !vm.formData.Email
        || !vm.myFile
        || !vm.fileName
      ) {
        vm.$swal({
          icon: 'warning',
          text: '尚有欄位未填寫',
          confirmButtonText: '確定',
        });
        return false;
      }
      const formData = new FormData();
      // formData.append('Id', vm.guid);
      formData.append('Name', vm.formData.Name);
      formData.append('Mobile', vm.formData.Mobile);
      formData.append('Telephone', vm.formData.Mobile);
      formData.append('Email', vm.formData.Email);
      formData.append('Affiliation', vm.formData.Affiliation);
      formData.append('Position', vm.formData.Position);
      formData.append('Filename', vm.fileName);
      formData.append('File', vm.myFile, vm.fullFileName);
      // console.log(vm.myFile);
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
      vm.$store.dispatch('updateLoading', true);

      // 測試用
      // vm.$swal({
      //   icon: 'success',
      //   text: '投稿成功!',
      //   confirmButtonText: '確定',
      // }).then(() => {
      //   vm.reset();
      // });

      // 正式用
      // eslint-disable-next-line no-undef
      SubmissionApi.postSubmissions(vm.Detail[0].Id, formData).then((res) => {
        // console.log(res);
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          vm.$swal({
            icon: 'success',
            title: '投稿成功!',
            text: `您的投稿編號為： ${res.data.Message}`,
            confirmButtonText: '確定',
          });
          vm.reset();
          // const UrlString = window.location.href;
          // const Url = new URL(UrlString);
          // vm.submissionId = Url.searchParams.get('Id');
        } else {
          vm.$swal({
            icon: 'error',
            text: '投稿失敗，請檢查您所填寫欄位及上傳的檔案，或著稍後在試!',
            confirmButtonText: '確定',
          });
        }
      });
      // vm.$refs.form.submit();
    },
    reset() {
      const vm = this;
      vm.formData = {
        Name: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
      };
      vm.deleteFile();
    },
    downloadFunction(url, params = {}) {
      const uA = window.navigator.userAgent;
      const isIE = /msie\s|trident\/|edge\//i.test(uA)
        && !!(
          'uniqueID' in document
          || 'documentMode' in document
          || 'ActiveXObject' in window
          || 'MSInputMethodContext' in window
        );

      let Type;
      if (params.type === 'paf' || params.type === 'PDF') {
        Type = 'application/pdf';
      } else if (params.type === 'doc') {
        Type = 'application/msword';
      } else {
        Type = `video/${params.type}`;
      }
      this.$http
        .get(url, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: Type });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `TADHfile.${params.type}`;

          if (isIE) {
            navigator.msSaveBlob(new Blob([data]), `TADHfile.${params.type}`);
          } else {
            link.click();
          }
        })
        .catch((err) => {
          // console.log('錯誤', err);
        });
      return true;
    },
    download(url) {
      const vm = this;
      const Type = url.split('/').pop().split('.').pop();
      vm.downloadFunction(url, { type: Type });
    },
  },
  created() {
    // $('#collapseOne').collapse('hide');
    const vm = this;
    vm.getMagazineList(vm.nowPage);
    vm.getSubmissionList();
    const UrlString = window.location.href;
    const Url = new URL(UrlString);
    const Id = 123; // Url.searchParams.get('Id');
    vm.submissionId = Url.searchParams.get('Id');
    vm.guid = Common.generateUUID();
    if (Id !== null) {
      // if (process.env.NODE_ENV === 'production') {
      //   // eslint-disable-next-line no-undef
      //   API.getSubmissionDetail({ Id }).then((res) => {
      //     if (res.Ok) {
      //       vm.Detail = res.Data;
      //     }
      //   });
      // } else {
      // vm.Detail = {
      //   Id: 'test0101',
      //   Title: '艾利根論文獎甄選活動!!',
      //   // Image: require('@/assets/dev/img2.png'),
      //   StartOn: '2019-07-11T00:00:00',
      //   EndOn: '2019-08-17T00:00:00',
      //   DocumentFile:
      //     'https://retinasociety.blob.core.windows.net/submission/eeb70bfb-ea96-4fb9-8957-59ec9131cf68/9a66c81ffdd24878b9821af506da5f22.doc',
      //   Content: `   <p>親愛的會員您好:</p>
      //         <p>
      //           今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
      //           <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
      //         </p>
      //         <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
      //         <ul>
      //           <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
      //           <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
      //           <li>
      //             (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
      //             <span
      //               style="backgroundColor:#ff0;"
      //             >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
      //           </li>
      //           <li>
      //             (四) 敬請各位會員於
      //             <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
      //           </li>
      //         </ul>
      //         <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
      //         <p>
      //           相關投稿事項請至IOIS網站:
      //           <a
      //             href="https://www.iois.info/page.php?edi_id=1463"
      //           >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
      //         </p>
      //         <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
      //         <p>中華民國視網膜醫學會 陳世真 理事長</p>
      //         <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
      //         <p>許淑娟 會長 敬邀</p>`,
      // };
      // }
    }
  },
  computed: {},
};
</script>

<style lang="scss">
.magazine-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 420px) {
    justify-content: center;
  }
  &:after {
    content: "";
    flex: 0 0 30%;
    width: 33.33333%;
    max-width: 325px;
  }
}
.submission_box .input_span label {
  display: block;
  padding: 5px 24px;
  background-color: #f68e56;
  color: #fff;
  // border-radius: 5px;
  cursor: pointer;
}
.submission_box .input_span .note {
  letter-spacing: 2px;
  padding: 5.5px 0;
}
.submission_box .input_span input[type="file"] {
  display: none;
}
.file_name {
  display: flex;
  align-items: center;
  flex: 1;
}
.file_name input {
  flex: 1;
  /* margin-right: 10px; */
}
.file_name .delete {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.file_name .delete span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
  width: unset;
  text-align: unset;
  margin-right: unset;
}
.file_name .delete span:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: unset;
  text-align: unset;
  margin-right: unset;
}

.fileArea {
  display: flex;
  align-items: center;
  width: 100%;

  label {
    margin-bottom: 0;
  }
}
</style>
